/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomPlaceCrossingType,
    CustomPlaceCrossingTypeFromJSON,
    CustomPlaceCrossingTypeFromJSONTyped,
    CustomPlaceCrossingTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomPlaceCrossingTstr
 */
export interface CustomPlaceCrossingTstr {
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingTstr
     */
    monitoredObjectId?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomPlaceCrossingTstr
     */
    clientId: number;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingTstr
     */
    customPlaceId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingTstr
     */
    timestamp: string;
    /**
     * 
     * @type {CustomPlaceCrossingType}
     * @memberof CustomPlaceCrossingTstr
     */
    type: CustomPlaceCrossingType;
    /**
     * 
     * @type {Date}
     * @memberof CustomPlaceCrossingTstr
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomPlaceCrossingTstr
     */
    deletedAt?: Date;
}

export function CustomPlaceCrossingTstrFromJSON(json: any): CustomPlaceCrossingTstr {
    return CustomPlaceCrossingTstrFromJSONTyped(json, false);
}

export function CustomPlaceCrossingTstrFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomPlaceCrossingTstr {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': !exists(json, 'monitored_object_id') ? undefined : json['monitored_object_id'],
        'clientId': json['client_id'],
        'customPlaceId': json['custom_place_id'],
        'timestamp': json['timestamp'],
        'type': CustomPlaceCrossingTypeFromJSON(json['type']),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}

export function CustomPlaceCrossingTstrToJSON(value?: CustomPlaceCrossingTstr | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'client_id': value.clientId,
        'custom_place_id': value.customPlaceId,
        'timestamp': value.timestamp,
        'type': CustomPlaceCrossingTypeToJSON(value.type),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}


